import api from '../libs/axios';

export const requestOTP = async (dto) => {
  const response = await api.post('/register/request/otp', dto);
  return response.data;
};

export const validateOTP = async (dto) => {
  const response = await api.post('/register/validate/otp', dto);
  return response.data;
};

export const registerUser = async (dto) => {
  const response = await api.post('/register', dto);
  return response.data;
};
